import { Building2, IdCard, Layers, LayoutGrid, User } from 'lucide-react';

/**
 * Icon per Records type. The list of TYPES is data (the endpoint decides what
 * exists), but an icon is presentation: a type this map does not know gets the
 * generic one instead of a blank slot, so a new type never breaks the rail.
 */
const RECORD_TYPE_ICONS = Object.freeze({
  all: LayoutGrid,
  customers: User,
  employees: IdCard,
  companies: Building2,
});

export const iconForRecordType = (typeId) => RECORD_TYPE_ICONS[typeId] ?? Layers;
